import React, { FC, memo, useEffect } from 'react'

import { useFocusNodeById, useSetFocus } from '@please/lrud'

import { focusIds } from '@/constants/focus'
import { paths } from '@/constants/paths'
import useStore from '@/store/useStore'
import { sendPageImpressionToGTAG } from '@/utils/utils'

import { ImageViewer } from './ImageViewer'
import { MediaPlayer } from './MediaPlayer'

const MediaPlayerPopupRaw: FC = () => {
  const mediaContent = useStore((state) => state.common.mediaVideo)
  const setFocus = useSetFocus()
  const focusNode = useFocusNodeById(focusIds.FULLSCREEN_PLAYER)

  useEffect(() => {
    mediaContent && sendPageImpressionToGTAG(paths.MEDIA_PLAYER)
  }, [mediaContent])

  useEffect(() => {
    focusNode && setFocus(focusIds.FULLSCREEN_PLAYER)
  }, [!!focusNode])

  if (!mediaContent) {
    return null
  }

  if (mediaContent.isImageType || mediaContent.isHtmlWidgetType) {
    return <ImageViewer mediaImage={mediaContent} />
  } else {
    return <MediaPlayer mediaVideo={mediaContent} />
  }
}

export const MediaPlayerPopup = memo(MediaPlayerPopupRaw)
